<template>

	<div>
		<div @mousedown="test()" class="menububble menububble is-active" style="left: 473px; bottom: 596px;">

			<button v-if="activeEditingText != false" class="menubar__button">


				<div>
					text
					<input type="text" v-model="activeEditingText" @keyup="changeActiveText" @keyup.enter="finishedEdititingText">

				</div>

			</button>

			<button v-if="activeEditingDotText != false" class="menubar__button">
				<div>
					text
					<input type="text" v-model="activeEditingDotText" @keyup="changeActiveDotText" @keyup.enter="finishedEdititingText">

				</div>

			</button>

			<button @click="createHtmlElement('h2')" class="menubar__button">
				H2
			</button>
			<button @click="createHtmlElement('h3')" class="menubar__button">
				H3
			</button>
			<button @click="createHtmlElement('h3')" class="menubar__button">
				p
			</button>
			<button @click="makeStyle('bold', 700)" class="menubar__button">
				<i class="fa fa-bold" aria-hidden="true"></i>
			</button>

			<button @click="makeDot()" class="menubar__button">
				<i class="fa fa-dot-circle-o" aria-hidden="true"></i>
			</button>

			<button  @click="changeActiveOption" class="menubar__button">

				<span v-if="activeOption != 'size'">Размер</span>
				<div v-else>
					Размер
					<input type="text"  @keyup.enter="makeStyle('size', $event.target.value)">

				</div>

			</button>

			<button @click="removeHtmlElement()" class="menubar__button">
				<i class="fa fa-trash-o" aria-hidden="true"></i>
			</button>

		</div>

		<div id="section-description" class="editor text-center section-slider" @mousedown="startDrag" @mousemove="doDrag">

			<div id="img-wrapper" style="z-index: -3">
				<img id="img-wrapper-img" src="https://cloud.perpao.com//files/felis/divani letto/amadeus/amadeus.jpg" alt="" style="z-index: -4">	
				
			</div>

		</div>


	</div>
</template>

<script>



	export default {
		name: 'editor-slider',

		props: {
			contentt: {
				type: String,
			}
		},
		watch: {

			tim() {
				console.log('sss')

			},
			
		},
		created() {



		 	window.addEventListener('mouseup', this.stopDrag);
		 	window.addEventListener('mousedown', this.chooseHtmlElement);
		 	// window.addEventListener('keyup', this.keyboardEvent);
		 	window.addEventListener('dblclick', this.dblClick);
		 	document.addEventListener('mousemove',function(e){
		 		if( e.target.getAttribute('unselectable')=='on' )
		 			e.target.ownerDocument.defaultView.getSelection().removeAllRanges();
		 	},false);
		 },
		 beforeDestroy() {
		 	window.removeEventListener('mouseup', this.stopDrag);
		 	window.removeEventListener('mousedown', this.clickEvent);
		 	// window.removeEventListener('keyup', this.keyboardEvent);
		 	window.removeEventListener('dblclick', this.dblClick);
		 },


		 data() {
		 	return {

		 		tim: '',
		 		dragging: false,
		 		activeElement: null,
		 		activeOption: 'null',
		 		activeOption: 'null',
		 		activeEditingText: false,
		 		activeEditingDotText: false,
		 		x: 'no',
		 		y: 'no'


		 	}
		 },


		 methods: {
		 	createHtmlElement(tag) {

		 		var width = document.getElementById('img-wrapper-img').offsetWidth
			var height = document.getElementById('img-wrapper-img').offsetHeight

			document.getElementById('img-wrapper').style.width = width + 'px'
			document.getElementById('img-wrapper').style.height = height + 'px'
		 		
		 		var para = document.createElement(tag);
		 		var node = document.createTextNode("New text.");

		 		var element = document.getElementById("section-description");

		 		element.appendChild(para);
		 		para.appendChild(node);

		 		if(this.activeElement) {
					// this.activeElement.style.border = 'none'
					this.cancelActiveElement()
				}
				this.activeElement = para
				this.activeEditingText = 'New text'

				this.activeElement.style.position = 'absolute'
				this.activeElement.style.border = '1px solid red'
			},
			makeStyle(key, value) {

				if(this.activeElement == null) {
					return
				}

				if(key == 'size') {
					this.activeElement.style.fontSize = value + 'px'
				}
				if(key == 'bold') {
					this.activeElement.style.fontWeight = value 
				}

				this.activeOption = null
			},
			makeDot() {
				
				var newElement = document.createElement('span');

				newElement.classList.add('stage-ibx__point');
				newElement.classList.add('p-absolute');
				newElement.style.top = this.y + '%'
				newElement.style.left = this.x + '%'
				newElement.style.opacity = '1'
				newElement.setAttribute('data-title', 'New text')


				var parentElement = document.getElementById("section-description")

				parentElement.appendChild(newElement);

				this.activeElement = newElement
				this.activeEditingDotText = 'New text'


			},
			removeHtmlElement() {
				this.activeElement.remove()


				this.cancelActiveElement()

			},
			chooseHtmlElement(e) {
				e.preventDefault()
				if( e.path[0].id != 'img-wrapper' && e.path[1].id == 'section-description') {
					this.activeElement = e.target
					this.activeElement.style.border = 'none'

					this.activeElement.style.border = '1px solid red'
					this.activeEditingText = this.activeElement.innerText
					console.log(this.activeElement.innerText)
				} else {
					return false

					// this.activeElement = null
					// this.activeEditingText = false
				}


			},


			dblClick(e) {
				if(this.activeElement == null) {
					return
				}
				console.log(document.getElementById('section-description').innerHTML)

			},
			finishedEdititingText(value) {
				// this.activeElement.innerText = value
				this.cancelActiveElement()
			},
			finishedEdititingText() {
				this.cancelActiveElement()

			},
			changeActiveText() {
				this.activeElement.innerText = this.activeEditingText
			},
			changeActiveDotText() {

				this.activeElement.setAttribute('data-title', this.activeEditingDotText)
			},

			startDrag() {
				this.dragging = true;
				this.x = this.y = 0;
			},
			stopDrag() {
				this.dragging = false;
				this.x = this.y = 'no';

			},
			doDrag(event) {

				if(this.activeElement == null) {
					return false
				}

				if (this.dragging) {
					this.x = event.clientX;
					this.y = event.clientY;
					

					var xCord = event.clientX;
					var yCord = event.clientY;

					this.y = yCord/document.getElementById("section-description").offsetHeight;

					this.x = event.offsetX==undefined?event.layerX:event.offsetX;
					this.y = event.offsetY==undefined?event.layerY:event.offsetY;
					
					this.x = this.x/document.getElementById("section-description").offsetWidth*100
					this.y = this.y/document.getElementById("section-description").offsetHeight*100

					this.x = this.x.toFixed(2)
					this.y = this.y.toFixed(2)

					if(this.x > 5.10) {
						console.log('_____')
						this.activeElement.style.top = this.y + '%'
						this.activeElement.style.left = this.x + '%'
					}

				}


			},
			cancelActiveElement() {
				this.activeElement.style.border = 'none'
				this.activeElement = null
				this.activeEditingText = null
				this.activeEditingDotText = null
			},
			changeActiveOption() {

				if(this.activeElement == null) {
					return false
				}
				this.activeOption = 'size'
			},
			
			mouseMove: function(e) {
			},

		

			

		},
	}

</script>


<style scoped>
/*! CSS Used from: https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css */
*,::after,::before{box-sizing:border-box;}
button{border-radius:0;}
button:focus{outline:1px dotted;outline:5px auto -webkit-focus-ring-color;}
button{margin:0;font-family:inherit;font-size:inherit;line-height:inherit;}
button{overflow:visible;}
button{text-transform:none;}
button{-webkit-appearance:button;}
button::-moz-focus-inner{padding:0;border-style:none;}
@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
}
/*! CSS Used from: https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css */
.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.fa-repeat:before{content:"\f01e";}
.fa-bold:before{content:"\f032";}
.fa-italic:before{content:"\f033";}
.fa-compress:before{content:"\f066";}
.fa-link:before{content:"\f0c1";}
.fa-list-ul:before{content:"\f0ca";}
.fa-list-ol:before{content:"\f0cb";}
.fa-strikethrough:before{content:"\f0cc";}
.fa-underline:before{content:"\f0cd";}
.fa-undo:before{content:"\f0e2";}
.fa-quote-right:before{content:"\f10e";}
.fa-code:before{content:"\f121";}
.fa-paragraph:before{content:"\f1dd";}
.fa-window-minimize:before{content:"\f2d1";}
/*! CSS Used from: Embedded */
button:hover{cursor:pointer;}
/*! CSS Used from: Embedded */
.menubar__button{font-weight:300;background:none;border:none;color:#fff;border-radius:3px;}
.menubar__button i{padding:5px;font-size:11px;}
.is-active{background:#ddd;}
.menububble {
	height: 100px;
	top: 100px;
}
.menububble{width:400px;position:absolute;display:-webkit-box;display:-ms-flexbox;display:block;z-index:20;margin-left:100px;background:#44536a;border-radius:5px;padding:.3rem;margin-bottom:.5rem;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);visibility:hidden;opacity:0;-webkit-transition:opacity .2s,visibility .2s;transition:opacity .2s,visibility .2s;}
.menububble.is-active{opacity:1;visibility:visible;}
.menububble__button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;background:rgba(0,0,0,0);border:0;color:#fff;padding:.2rem .5rem;margin-right:.2rem;border-radius:3px;cursor:pointer;}
.menububble__button:last-child{margin-right:0;}
.menububble__button:hover{background-color:hsla(0,0%,100%,.1);}
.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
/*! CSS Used fontfaces */
@font-face{font-family:'FontAwesome';src:url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.eot?v=4.7.0');src:url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.eot#iefix&v=4.7.0') format('embedded-opentype'),url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.woff2?v=4.7.0') format('woff2'),url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.woff?v=4.7.0') format('woff'),url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.ttf?v=4.7.0') format('truetype'),url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.svg?v=4.7.0#fontawesomeregular') format('svg');font-weight:normal;font-style:normal;}
#section-description {
	width: 100%;

	transform: translateX(0px);
	/*transition-duration: 300ms;*/
	/*background: url(https://cloud.perpao.com//files/5555.jpg);*/
	/*background-size: contain;*/
}
#section-description img {
	position: relative;
}
p {
	position: absolute;
}



/*! CSS Used from: https://perpao.bg/css/home1.css */
*,::after,::before{box-sizing:border-box;}
figure{display:block;}
h2{margin-top:0;margin-bottom:.5rem;}
figure{margin:0 0 1rem;}
img{vertical-align:middle;border-style:none;}
h2{margin-bottom:.5rem;font-family:inherit;font-weight:500;line-height:1.2;color:inherit;}
h2{font-size:2rem;}
.text-center{text-align:center!important;}
@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
	img{page-break-inside:avoid;}
	h2{orphans:3;widows:3;}
	h2{page-break-after:avoid;}
}
img{max-width:100%;}
.p-absolute{position:absolute;}
.slider.slider-active{overflow:hidden;}
.slider.slider-active .slider-slides>*{float:left;}
figure{position:relative;height:calc(100vh - 93px);}
figure img{width:100%;height:auto;}
.pp-slider-content{position:absolute;width: 100%;}
@media (max-width: 575px){
	h2{font-size:16px!important;}
}
/*! CSS Used from: https://perpao.bg/css/home1.css */
*,::after,::before{box-sizing:border-box;}
svg:not(:root){overflow:hidden;}
.text-center{text-align:center!important;}
@media print{
	*,::after,::before{text-shadow:none!important;box-shadow:none!important;}
}
.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.fa-chevron-down:before{content:"\f078";}
.p-absolute{position:absolute;}
.bottom-slider{bottom:-8px;width:100%;}
.bottom-slider .svgbottomslider{bottom:0;margin-bottom:-14.4px;}
.bottom-slider .glyphicon,.bottom-slider .svgbottomslider{position:absolute;left:50%;color:#000;transform:translateX(-50%);}
.bottom-slider .glyphicon{bottom:5px;font-size:22px;opacity:.2;height:26px;margin-left:2px;}
.fa,.glyphicon{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}


.stage-ibx__point[data-title]:hover:before {
	opacity: 1;
	margin-bottom: 20px;
}
/*! CSS Used fontfaces */
@font-face{font-family:'FontAwesome';src:url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.eot?v=4.7.0');src:url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.eot#iefix&v=4.7.0') format('embedded-opentype'),url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.woff2?v=4.7.0') format('woff2'),url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.woff?v=4.7.0') format('woff'),url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.ttf?v=4.7.0') format('truetype'),url('https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/fonts/fontawesome-webfont.svg?v=4.7.0#fontawesomeregular') format('svg');font-weight:normal;font-style:normal;}

</style>	


// WEBPACK FOOTER //
// src/components/app_modules/EditorSlider.vue